'use client';
import BrandFilters from '../widgets/BrandFilters';
import CategoryFilters from '../widgets/CategoryFilters';
import { useEffect } from 'react';
import Modal from 'react-modal';
import { useRouterParams } from '@/app/_hooks/useRouterParams';
import ContactUsWidget from '../widgets/ContactUsWidget';

export default function CatAside({
  object,
  openMobileSide,
  onCloseModalHandler,
}) {
  const { addParam, removeParam, clearParams } = useRouterParams();

  const customStyles = {
    content: {
      top: '0',
      right: '0',
      width: '300px',
      bottom: '0',
      border: 'none',
      inset: 'unset',
      height: '100%',
    },

    overlay: {
      zIndex: '20',
    },
  };
  const resetFilters = () => {
    clearParams();
  };

  useEffect(() => {
    if (openMobileSide) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [openMobileSide]);

  const handleBrandFilter = (e) => {
    if (e.target.checked) {
      addParam(e.target.name, e.target.id);
    } else {
      removeParam(e.target.name, e.target.id);
    }
  };

  return (
    <>
      <div className="hidden lg:block">
        <div className="w-[335px] test brand-sidebar pl-6">
          <div className="stick-sidebar sticky top-0">
            <div className="hidden lg:block">
              <ContactUsWidget />
            </div>
            <div className="sidebar-head flex justify-between p-4 pt-0">
              <span className="">فیلترها</span>
              <span
                className="text-xs text-ocean-blue cursor-pointer"
                onClick={resetFilters}
              >
                حذف فیلترها
              </span>
            </div>
            <div className="filters-archive">
              {object.category.inverse_relatives.length > 0 && (
                <BrandFilters
                  brands={object.category.inverse_relatives}
                  onChange={handleBrandFilter}
                />
              )}

              <CategoryFilters
                Categories={object.category.sub_categories}
                onChange={handleBrandFilter}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="block lg:hidden">
        <Modal
          isOpen={openMobileSide}
          onRequestClose={onCloseModalHandler}
          style={customStyles}
          ariaHideApp={false}
        >
          <div className="sidebar-head flex justify-between p-4 pt-0">
            <span className="">فیلترها</span>
            <span className="text-xs text-ocean-blue cursor-pointer">
              حذف فیلترها
            </span>
          </div>
          {object.category.inverse_relatives.length > 0 && (
            <BrandFilters
              brands={object.inverse_relatives}
              onChange={handleBrandFilter}
            />
          )}
          <CategoryFilters
            Categories={object.category.sub_categories}
            onChange={handleBrandFilter}
          />
        </Modal>
      </div>
    </>
  );
}
